import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "../../styled";
const HeadingContainer = styled.div`
  position: relative;
  display: block;
  color: ${(props)=>props.color};
`;
const Subtitle = styled.div`
  position: absolute;
  top: 14px;
  font-size: 10px;
  color: ${(props)=>props.color};
`;
export const Heading = ({ as, children, subtitle, subtitleColor, color, margin, padding, lineHeight })=>{
    const HeadingElement = as;
    return /*#__PURE__*/ _jsxs(HeadingContainer, {
        color: color != null ? color : '#000000',
        children: [
            subtitle && /*#__PURE__*/ _jsx(Subtitle, {
                color: subtitleColor != null ? subtitleColor : '#000000',
                children: subtitle
            }),
            /*#__PURE__*/ _jsx(HeadingElement, {
                style: {
                    padding: padding,
                    margin: margin,
                    lineHeight: lineHeight
                },
                children: children
            })
        ]
    });
};
export default Heading;
